import React, { useContext, useState, useEffect } from 'react';
import PaymentContext from '../../../../context/Payment/Context';
import { priceCheck } from '../../../../assets/images/Global';
import FlowCreditCard from './components/CreditCard';
import FlowOxxo from './components/Oxxo';
import FlowSpei from './components/SPEI';
import FlowAtrato from './components/Atrato';
import Constants from '../../../../utils/Constants';
import AlertModal from '../../../AlertModal';
import { axiosPutRecalculateCarts } from '../../../../methods/products/axiosPut';
import { areThereCartsWithoutEnoughStock } from '../../../../utils/stock';

const MethodsFlow = () => {
  const paymentContext = useContext(PaymentContext);
  const [preventModal, setPreventModal] = useState(false);
  const { dashboard } = paymentContext;
  const { isMexico, isColombia } = Constants;
  const carts = new URLSearchParams(window.location.search).getAll('cart');
  const buttonUrl = new URLSearchParams(window.location.search).get(
    'redirectUrl',
  );

  const outOfStockModal = {
    title: '¡Lo sentimos!',
    description:
      'Uno de los productos de tu carrito ya no está disponible. Regresa a la tienda y vuelve a hacer tu selección.',
    button: 'Regresar a la tienda',
    imgAlert: priceCheck,
    urlRedirect: buttonUrl,
    discardLink: buttonUrl,
  };

  useEffect(() => {
    (async () => {
      try {
        const { data: upToDateCartData } = await axiosPutRecalculateCarts(carts);

        if (!areThereCartsWithoutEnoughStock(upToDateCartData.carts)) return;
        setPreventModal(true);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        setPreventModal(false);
      }
    })();
  }, [dashboard]);

  return (
    <>
      {preventModal && <AlertModal data={outOfStockModal} modal={false} discardOption={false} />}
      {isMexico && (
        <>
          {dashboard === 'card' && <FlowCreditCard />}
          {dashboard === 'oxxo' && <FlowOxxo />}
          {dashboard === 'spei' && <FlowSpei />}
          {dashboard === 'atrato' && <FlowAtrato />}
        </>
      )}
      {isColombia && (
        <>
          {dashboard === 'card' && <FlowCreditCard />}
          {dashboard === 'spei' && <FlowSpei />}
        </>
      )}
    </>
  );
};

export default MethodsFlow;
